// @flow
import { call, put, takeLatest, select } from "redux-saga/effects";
import * as _ from "lodash";
import API from "../../api";

import * as ActionTypes from "../../constants/ActionTypes";
import * as Actions from "../../actions";

function* userlogin(action: Object) {
  try {
    const response = yield API.get(`/users/account/get-profile`);
    yield put(Actions.userloginSuccess(response.response.user[0]));
  } catch (error) {
    yield put(Actions.userloginFailure(error));
  }
}

function* userSociallogin(action: Object) {
  try {
    const response = yield API.get(`/users/account/get-profile`, {
      withCredentials: true
    });
    yield put(Actions.userSocialloginSuccess(response.response.user));
  } catch (error) {
    yield put(Actions.userSocialloginFailure(error));
  }
}

function* userlogout(action: Object) {
  try {
    yield put(Actions.userlogoutSuccess());
  } catch (error) {
    yield put(Actions.userlogoutFailure(error));
  }
}

function* userresetPassword(action: Object) {
  try {
    const response = yield API.post(
      `/users/account/change-password`,
      action.payload
    );

    yield put(Actions.userresetPasswordSuccess(response));
  } catch (error) {
    yield put(Actions.userresetPasswordFailure(error));
  }
}

function* userregister(action: Object) {
  try {
    const response = yield API.post(`/users/register`, action.payload);
    yield put(Actions.userregisterSuccess(response));
  } catch (error) {
    yield put(Actions.userregisterFailure(error));
  }
}

function* usergetUserProfile(action: Object) {
  try {
    const response = yield API.get(
      `/users/account/get-profile`,
        { withCredentials: true }
    );

    yield put(Actions.usergetUserProfileSuccess(response.response.user[0]));
  } catch (error) {
    yield put(Actions.usergetUserProfileFailure(error));
  }
}

function* userupdateUserProfile(action: Object) {
  try {
    const response = yield API.post(
      `/users/account/get-profile`,
        { withCredentials: true }
    );

    yield put(Actions.userupdateUserProfileSuccess(response));
  } catch (error) {
    yield put(Actions.userupdateUserProfileFailure(error));
  }
}

function* usergetBillingAddress(action: Object) {
  try {
    const response = yield API.get(
      `/users/account/get-billing-address`,
        { withCredentials: true }
    );

    yield put(Actions.usergetBillingAddressSuccess(response));
  } catch (error) {
    yield put(Actions.usergetBillingAddressFailure(error));
  }
}
function* userupdateBillingAddress(action: Object) {
  try {
    const response = yield API.put(
      `/users/account/update-billing-address`,
        { withCredentials: true }
    );

    yield put(Actions.userupdateBillingAddressSuccess(response));
  } catch (error) {
    yield put(Actions.userupdateBillingAddressFailure(error));
  }
}

function* usergetUserLocationAddress(action: Object) {
  try {
    const usergetUserGeoLocation = () =>
        new Promise((resolve, reject) => {
          var options = {
            timeout: 5000,
            maximumAge: 0,
            enableHighAccuracy: true
          };
          navigator.geolocation.getCurrentPosition(
              (location) => resolve(location),
              (error) => reject(error),
              options
          );
        });

    const response = yield call(usergetUserGeoLocation);
    const { latitude, longitude } = response.coords;

    const query = {
      lat: latitude,
      lng: longitude,
    };

    const addresses = yield API.get(`/address`, { params: query });

    yield put(Actions.usergetUserLocationAddressSuccess(response.addresses[0]));
  } catch (error) {
    yield put(Actions.usergetUserLocationAddressFailure(error));
  }
}

// Virtual Try-On Profile Image Sagas

function* uploadTryOnProfileImage(action: Object) {
  try {
    const response = yield API.post(
      `/users/shopping/profile-image`,
      action.payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    yield put(Actions.uploadTryOnProfileImageSuccess(response));
    // Refresh the list of all images after upload
    yield put(Actions.getAllTryOnProfileImages());
  } catch (error) {
    yield put(Actions.uploadTryOnProfileImageFailure(error));
  }
}

function* getTryOnProfileImage(action: Object) {
  try {
    const response = yield API.get(`/users/shopping/profile-image`);

    yield put(Actions.getTryOnProfileImageSuccess(response));
  } catch (error) {
    yield put(Actions.getTryOnProfileImageFailure(error));
  }
}

function* deleteTryOnProfileImage(action: Object) {
  try {
    const { imageId } = action.payload || {};
    const url = imageId 
      ? `/users/shopping/profile-image/${imageId}`
      : `/users/shopping/profile-image`;
    yield API.delete(url);
    yield put(Actions.deleteTryOnProfileImageSuccess());
    // Refresh the list of all images after deletion
    yield put(Actions.getAllTryOnProfileImages());
  } catch (error) {
    yield put(Actions.deleteTryOnProfileImageFailure(error));
  }
}

function* getAllTryOnProfileImages(action: Object) {
  try {
    const response = yield API.get(`/users/shopping/profile-images`);

    yield put(Actions.getAllTryOnProfileImagesSuccess(response));
  } catch (error) {
    yield put(Actions.getAllTryOnProfileImagesFailure(error));
  }
}

// Virtual Try-On Generation Sagas
function* generateVirtualTryOn(action: Object) {
  try {
    const { product_id, user_image_id, numberOfImages, force_duplicate } = action.payload;
    
    const formData = new FormData();
    formData.append("product_id", product_id);
    if (user_image_id) {
      formData.append("user_image_id", user_image_id);
    }
    if (numberOfImages) {
      formData.append("numberOfImages", numberOfImages);
    }
    if (force_duplicate) {
      formData.append("force_duplicate", force_duplicate);
    }
    
    const response = yield API.post(
      `/users/shopping/generate`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    
    yield put(Actions.generateVirtualTryOnSuccess(response));
  } catch (error) {
    yield put(Actions.generateVirtualTryOnFailure(error));
  }
}

function* getTryOnCredits(action: Object) {
  try {
    const response = yield API.get(`/users/shopping/credits`);

    yield put(Actions.getTryOnCreditsSuccess(response));
  } catch (error) {
    yield put(Actions.getTryOnCreditsFailure(error));
  }
}

function* getTryOnHistory(action: Object) {
  try {

    const { shopId = "", limit = 20, skip = 0 } = action.payload;

    const response = yield API.get(`/users/shopping/history?shop=${shopId}&limit=${limit}&skip=${skip}`);

    yield put(Actions.getTryOnHistorySuccess(response));
  } catch (error) {
    yield put(Actions.getTryOnHistoryFailure(error));
  }
}

function* getTryOnDetails(action: Object) {
  try {
    const { tryonId } = action.payload;
    const response = yield API.get(`/users/shopping/${tryonId}`);

    yield put(Actions.getTryOnDetailsSuccess(response));
  } catch (error) {
    yield put(Actions.getTryOnDetailsFailure(error));
  }
}

function* deleteTryOn(action: Object) {
  try {
    const { tryonId } = action.payload;
    const response = yield API.delete(`/users/shopping/${tryonId}`);
    yield put(Actions.deleteTryOnSuccess({ ...response, tryonId }));
    // Refresh history after delete
    yield put(Actions.getTryOnHistory());
  } catch (error) {
    yield put(Actions.deleteTryOnFailure(error));
  }
}

export default function* AppBaseSaga(): Generator<*, *, *> {
  yield takeLatest(ActionTypes.USER_LOGIN_START, userlogin);
  yield takeLatest(ActionTypes.USER_SOCIAL_LOGIN_START, userSociallogin);
  yield takeLatest(ActionTypes.USER_LOGOUT_START, userlogout);
  yield takeLatest(ActionTypes.USER_REGISTER_START, userregister);
  yield takeLatest(ActionTypes.USER_RESET_PASSWORD_START, userresetPassword);
  yield takeLatest(ActionTypes.USER_GET_USER_PROFILE_START, usergetUserProfile);
  yield takeLatest(ActionTypes.USER_UPDATE_USER_PROFILE_START, userupdateUserProfile);
  yield takeLatest(ActionTypes.USER_GET_BILLING_ADDRESS_START, usergetBillingAddress);
  yield takeLatest(
    ActionTypes.USER_UPDATE_BILLING_ADDRESS_START,
      userupdateBillingAddress
  );
  yield takeLatest(ActionTypes.USER_GET_USER_LOCATION_START, usergetUserLocationAddress);
  
  // Virtual Try-On Profile Image Watchers
  yield takeLatest(ActionTypes.UPLOAD_TRYON_PROFILE_IMAGE_START, uploadTryOnProfileImage);
  yield takeLatest(ActionTypes.GET_TRYON_PROFILE_IMAGE_START, getTryOnProfileImage);
  yield takeLatest(ActionTypes.GET_ALL_TRYON_PROFILE_IMAGES_START, getAllTryOnProfileImages);
  yield takeLatest(ActionTypes.DELETE_TRYON_PROFILE_IMAGE_START, deleteTryOnProfileImage);
  
  // Virtual Try-On Generation Watchers
  yield takeLatest(ActionTypes.GENERATE_VIRTUAL_TRYON_START, generateVirtualTryOn);
  yield takeLatest(ActionTypes.GET_TRYON_CREDITS_START, getTryOnCredits);
  yield takeLatest(ActionTypes.GET_TRYON_HISTORY_START, getTryOnHistory);
  yield takeLatest(ActionTypes.GET_TRYON_DETAILS_START, getTryOnDetails);
  yield takeLatest(ActionTypes.DELETE_TRYON_START, deleteTryOn);
}
